(function() {
    'use strict';
    angular
        .module('portalApp')
        .factory('Round', Round);

    Round.$inject = ['$resource', 'DateUtils'];

    function Round ($resource, DateUtils) {
        var resourceUrl =  'api/rounds/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                        data.created = DateUtils.convertLocalDateFromServer(data.created);
                        data.lastHist = DateUtils.convertLocalDateFromServer(data.lastHist);
                        data.lastFore = DateUtils.convertLocalDateFromServer(data.lastFore);
                    }
                    return data;
                }
            },
            'update': {
                method: 'PUT',
                transformRequest: function (data) {
                    data.created = DateUtils.convertLocalDateToServer(data.created);
                    data.lastHist = DateUtils.convertLocalDateToServer(data.lastHist);
                    data.lastFore = DateUtils.convertLocalDateToServer(data.lastFore);
                    return angular.toJson(data);
                }
            },
            'save': {
                method: 'POST',
                transformRequest: function (data) {
                    data.created = DateUtils.convertLocalDateToServer(data.created);
                    data.lastHist = DateUtils.convertLocalDateToServer(data.lastHist);
                    data.lastFore = DateUtils.convertLocalDateToServer(data.lastFore);
                    return angular.toJson(data);
                }
            }
        });
    }
})();
